import {WithdrawChooseOption} from "./loveStoryConst";
import WithdrawNode from "./WithdrawNode";
import NormalGameManager from "../../manager/NormalGameManager";
import data_control from "../../../../engines/libs/data_control";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 * 提现item
 */
@ccclass
export default class WithdrawItemNode extends cc.Component {

    @property({type:cc.Label,displayName:"名字文本"})
    lbDesc:cc.Label = null;
    @property({type:cc.Label,displayName:"数值文本"})
    lbTotal:cc.Label = null;


    //选项数据
    private mWithdrawChooseOption : WithdrawChooseOption;
    private mParentScript : WithdrawNode;


    onLoad () {}

    start () {

    }

    //绑定数据
    bindData( parentScript : WithdrawNode , withdrawChooseOption : WithdrawChooseOption ){
        this.mParentScript = parentScript;
        this.mWithdrawChooseOption = withdrawChooseOption;
        this.lbDesc.string = `${this.mWithdrawChooseOption.chooseDesc}`;
        this.lbTotal.string = `(${ data_control.getNumberFormat( this.mParentScript.mPeopleMap.totalCoin * this.mWithdrawChooseOption.withdrawCoinsPercent / 100 ,1 ) })`;
    }

    /**
     * 点击
     */
    onBtnClick(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( this.mParentScript.checkLabelNum() == false ) {
            // 今日机会已用完
            this.mParentScript.addWithCountPrefab( this.mWithdrawChooseOption );
            return;
        }
        this.mParentScript.mPeopleMap.currDayWithdraw++;
        NormalGameManager._instance.loveStroyManager.writeData();
        this.mParentScript.mCompleteFun( this.mWithdrawChooseOption );
        this.mParentScript._close();
    }

}
